<button type="button" #airwallexTransactionDetailsButton
    class="btn-shout-fab btn-shout-sm btn-shout-fab-confirm"
    aria-label="View Airwallex transfer details"
    appTooltip="View Airwallex transfer"
    position="left"
    (click)="findTransactionDetails()">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="m21 21-4.34-4.34" />
        <circle cx="11" cy="11" r="8" />
    </svg>
</button>

<el-dialog>
    <dialog #airwallexTransactionDetailsDialog [id]="dialogId()"
        [attr.aria-labelledby]="titleId()"
        class="fixed inset-0 size-auto max-h-none max-w-none overflow-hidden bg-transparent backdrop:bg-transparent">
        <el-dialog-backdrop (click)="closeDrawer()"
            class="fixed inset-0 z-10 w-dvw overflow-hidden green-noise-bg opacity-100 transition-opacity ease-in-out data-closed:opacity-0 data-enter:duration-300 data-leave:duration-200">
        </el-dialog-backdrop>
        <div tabindex="0" class="absolute inset-0 pl-10 focus:outline-none sm:pl-16 z-20"
            (click)="$event.stopPropagation()">

            <el-dialog-panel
                class="ml-auto block size-full max-w-2xl transform transition-transform ease-in-out data-closed:translate-x-full data-enter:duration-300 data-leave:duration-200 p-4"
                (click)="$event.stopPropagation()">
                <div class="relative flex h-full flex-col overflow-y-auto shadow-xl rounded-xl ">

                    <div class="h-full flex flex-col overflow-hidden divide-y divide-border">

                        <!-- header -->
                        <div class="px-2 py-4 drawer-header-primary">
                            <div
                                class="flex flex-row w-full items-center justify-between space-x-3 h-full items-center">
                                <div class="min-w-0 flex-1 px-2">
                                    <p [id]="titleId()" class="text-md font-semibold text-primary text-left">
                                        Airwallex Transaction Details
                                    </p>
                                    <p class="text-sm text-secondary text-left">
                                        View the details of the Airwallex transaction.
                                    </p>
                                </div>

                                <div class="h-full flex flex-row items-start gap-2">
                                    @if (canDownloadConfirmation()) {
                                    <button type="button"
                                        class="btn-shout btn-shout-sm btn-shout-secondary shrink-0"
                                        [disabled]="downloadingConfirmation()"
                                        (click)="downloadConfirmationLetter()">
                                        {{ downloadingConfirmation() ? 'Downloading…' : 'Download confirmation' }}
                                    </button>
                                    }
                                    <button type="button" (click)="closeDrawer()"
                                        class="btn-fab-secondary text-secondary" aria-label="Close">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="size-5" aria-hidden="true">
                                            <path d="M18 6 6 18" />
                                            <path d="m6 6 12 12" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <!-- header - END -->

                        <!-- main content -->
                        @if (airwallexTransfer()) {
                        <div
                            class="relative h-full flex-1 flex flex-col items-start justify-start w-full overflow-hidden drawer-body-primary divide-y divide-border text-left p-2">
                            <div class="h-full w-full overflow-auto">
                                <pre><code>{{ airwallexTransfer() | json }}</code></pre>
                            </div>
                        </div>
                        }
                        @else {
                        <div
                            class="relative h-full flex-1 flex flex-col items-center justify-center w-full overflow-hidden drawer-body-primary divide-y divide-border text-left p-2 overflow-auto">
                            <div class="text-center">
                                <svg aria-hidden="true"
                                    class="mx-auto w-16 h-16 text-primary/15 animate-spin dark:text-gray-600 fill-primary"
                                    viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                        fill="currentColor" />
                                    <path
                                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                        fill="currentFill" />
                                </svg>
                                <h3 class="mt-2 text-sm font-semibold text-gray-900 dark:text-white">Loading</h3>
                                <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">Fetching from AirWallex
                                    directly...</p>
                            </div>
                        </div>
                        }
                        <!-- main content - END -->
                    </div>

                </div>
            </el-dialog-panel>

        </div>
    </dialog>
</el-dialog>
